import apiCall from "@/data/axios"
interface GetEagleEyeCloudSingleCameraAsync {
  AipxToken: string;
  CameraId :  string;
}


const getEagleEyeCloudSingleCameraAsync = async (body: GetEagleEyeCloudSingleCameraAsync) => {
  try {
    console.log(body);

    const response = await apiCall("POST", `/eagleeyecloud/camera/single`, body);
    console.log(response.data)
    return response.data;
  } catch (error: any) {
    console.error("getEagleEyeCloudSingleCameraAsync Error:", error);
    return {
      message: error.message || "An unexpected error occurred."
    };
  }
};

export default getEagleEyeCloudSingleCameraAsync;
export type { GetEagleEyeCloudSingleCameraAsync };